import React, { FC } from "react";
import NextButtonCarousel from "../../../assets/icon/ButtonCarousel";
import { IPlaylists } from "../../../types/playlists";

interface CustomArrowProps {
  playlists: IPlaylists[];
  responsive: any;
  next?: () => void;
  previous?: () => void;
}

const PlaylistsCustomButtonGroup: FC<CustomArrowProps> = ({
  next,
  previous,
  responsive,
  playlists,
}) => {


  const maxVisibleItems = responsive.desktop.items;
  const hideButtons = playlists.length <= maxVisibleItems;

  return (
    <div>
      {!hideButtons && (
        <div
          className="md:w-[100px] md:h-full md:absolute md:left-[0] md:top-[0]"
          style={{
            background:
              "linear-gradient(90deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)",
          }}
        >
          <button
            className="hidden md:flex md:justify-center md:items-center md:bg-white md:rounded-full md:w-10 md:h-10 md:shadow-md md:absolute md:left-0 md:top-[4.5rem] md:ml-3 md:rotate-180"
            onClick={previous}
          >
            <NextButtonCarousel />
          </button>
        </div>
      )}

      {!hideButtons && (
        <div
          className="md:w-[100px] md:h-full md:absolute md:-right-[13px] md:top-[0]"
          style={{
            background:
              "linear-gradient(270deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)",
          }}
        >
          <button
            className={
              "md:flex md:justify-center md:items-center md:bg-white md:rounded-full md:w-10 md:h-10 md:shadow-md md:absolute md:right-2.5 md:top-[4.5rem] md:mr-3"
            }
            onClick={next}
          >
            <div className="hidden md:block">
              <NextButtonCarousel />
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default PlaylistsCustomButtonGroup;
